const STORAGE_KEY = 'web_payment_dark';

function prefersDark(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/** Aplica clase `dark` en `<html>` según localStorage o preferencia del sistema. */
export function applyWebPaymentThemeFromStorage(): void {
  if (typeof document === 'undefined') return;
  const saved = localStorage.getItem(STORAGE_KEY);
  const dark = saved === null ? prefersDark() : saved === 'true';
  document.documentElement.classList.toggle('dark', dark);
}

export function isWebPaymentDark(): boolean {
  if (typeof document === 'undefined') return false;
  return document.documentElement.classList.contains('dark');
}

/** Conmuta tema y persiste. Devuelve si quedó oscuro. */
export function toggleWebPaymentDarkMode(): boolean {
  const next = !isWebPaymentDark();
  document.documentElement.classList.toggle('dark', next);
  localStorage.setItem(STORAGE_KEY, String(next));
  return next;
}

export function initWebPaymentTheme(): void {
  applyWebPaymentThemeFromStorage();
  if (typeof window === 'undefined') return;
  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', () => {
      if (localStorage.getItem(STORAGE_KEY) === null) {
        applyWebPaymentThemeFromStorage();
      }
    });
}
